import { readB2BInternals } from '../../utils/internal.mjs';
import { useStytchClient } from './useStytchClient.mjs';

const useB2BInternals = ()=>{
    const client = useStytchClient();
    return readB2BInternals(client);
};

export { useB2BInternals };
//# sourceMappingURL=useB2BInternals.mjs.map
